interface CircleCheckGreenProps {
  width?: string;
  height?: string;
}

const CircleCheckGreen = ({ width = "12", height = "12" }: CircleCheckGreenProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clipPath="url(#clip0_3747_59958)">
      <path
        opacity="0.28"
        d="M5.99967 10.9993C8.76092 10.9993 10.9993 8.76092 10.9993 5.99967C10.9993 3.23843 8.76092 1 5.99967 1C3.23843 1 1 3.23843 1 5.99967C1 8.76092 3.23843 10.9993 5.99967 10.9993Z"
        fill="#057A55"
      />
      <path
        d="M10.9363 2.39538L10.5033 2.69108C8.75193 3.88718 7.29489 5.46532 6.24205 7.30653L6.04569 7.64993L4.14705 5.45347M10.9175 5.0908C11.253 6.91308 10.5581 8.85143 8.96627 10.0247C6.7435 11.6629 3.61355 11.189 1.97533 8.96627C0.337104 6.7435 0.810967 3.61355 3.03373 1.97533C4.62557 0.802107 6.68269 0.712126 8.32396 1.57199"
        stroke="#057A55"
        strokeWidth="1.09282"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3747_59958">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CircleCheckGreen;
